import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { putComment } from '../../../api/comments';

import { generateCommentCIDKey } from '../../../components/Comments/utils/generateCommentCIDKey';
import { REQUEST } from '../../../constants/request';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { mergeCommentWithUserData } from '../../../utils/comments';

export const updateComment = createAsyncThunk(
  'comments/updateComment',
  async (commentContent, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [commentResponse, userdataResponse] = await putComment(
        commentContent,
        {
          cancelToken: source.token,
        },
      );

      return mergeCommentWithUserData(commentResponse, userdataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const { comments } = getState().comments;
      const commentCIDKey = generateCommentCIDKey(path);

      return (
        comments.comment.actions.create.request[commentCIDKey]?.loading !==
        REQUEST.pending
      );
    },
  },
);

export const updateCommentExtraReducers = builder => {
  builder
    .addCase(updateComment.pending, (state, action) => {
      const { path } = action.meta.arg;
      const commentCIDKey = generateCommentCIDKey({
        ...path,
        commentId: path.inReplyTo,
      });
      checkAndSetLoadingWithId(
        state.comments.comment.actions.update.request,
        action,
        commentCIDKey,
      );
    })
    .addCase(updateComment.fulfilled, (state, action) => {
      const { path } = action.meta.arg;
      const commentCIDKey = generateCommentCIDKey({
        ...path,
        commentId: path.inReplyTo,
      });
      onMatchedRequest(
        state.comments.comment.actions.update.request[commentCIDKey],
        action,
        () => {
          state.comments.comment.byId[commentCIDKey] = action.payload;
        },
      );
    })
    .addCase(updateComment.rejected, (state, action) => {
      const { path } = action.meta.arg;
      const commentCIDKey = generateCommentCIDKey({
        ...path,
        commentId: path.inReplyTo,
      });
      handleRequestRejection(
        state.comments.comment.actions.update.request[commentCIDKey],
        action,
      );
    });
};
